export * from './modal.component';
export * from './modal.service';
export * from './modal.module';